import type { CoachingSection } from "@app/analytics/MeetingReport/types";

import CoachingClarity from "./CoachingClarity";
import CoachingImpact from "./CoachingImpact";
import CoachingInclusion from "./CoachingInclusion";
import type { CoachingSectionProps } from "./types";

type TabbedCoachingContentProps = CoachingSectionProps & {
  selectedSection: CoachingSection;
};

const TabbedCoachingContent = ({
  selectedSection,
  ...moduleProps
}: TabbedCoachingContentProps) => {
  switch (selectedSection) {
    case "inclusion":
      return <CoachingInclusion {...moduleProps} />;
    case "impact":
      return <CoachingImpact {...moduleProps} />;
    case "clarity":
    default:
      return <CoachingClarity {...moduleProps} />;
  }
};

export default TabbedCoachingContent;
